export default {"src":"/oferta/_next/static/media/check-gray.4fdb4cdc.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};